import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
export const Container = styled.div`
  background: ${props => getBackgroundColor('white')(props)};
  border-radius: ${props => themeGet('space.2')(props)}px;
  padding: 20px 28px;
  text-align: left;
  max-width: 421px;
  width: 100%;
  height: 137px;
  position: relative;
  border: 1px solid #e0e0e0;
  padding-bottom: 30px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 20px;
    background: #f5f5f5;
    border-radius: 0 15px 15px 0;
    border: 1px solid #e0e0e0;
  }

  &::before {
    top: 30px;
    left: -1px;
    border-left-color: #f5f5f5;
  }

  &::after {
    bottom: 30px;
    left: -1px;
    border-left-color: #f5f5f5;
  }
`;
export const SideCut = styled.div`
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 20px;
    background: #f5f5f5;
    border-radius: 15px 0 0 15px;
    border: 1px solid #e0e0e0;
  }

  &::before {
    top: 30px;
    right: -1px;
    border-right-color: #f5f5f5;
  }

  &::after {
    bottom: 30px;
    right: -1px;
    border-right-color: #f5f5f5;
  }
`;
export const DashedLine = styled.div`
  position: absolute;
  top: 40px;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
  border-top: 1px dashed #e0e0e0;
`;
export const CouponHeader = styled.div`
  font-weight: bold;
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  margin-bottom: 12px;
  color: ${props => themeGet('colors.black')(props)};
  text-align: left;
`;
export const CouponContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 0;
  gap: ${props => themeGet('space.2')(props)}px;
`;